import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ErrorMessage, ModalFormContainer } from '..';
import { IdentityContext } from '../../context';
import {
  useCreate, useIndex, useUpdate
} from '../../hooks';
import { ButtonBar, Input } from '../basic-inputs';


export function Address() {
  const navigate = useNavigate();
  const { person } = useContext(IdentityContext);

  const { data: addresses, loading } = useIndex('addresses', { person_id: person?.id || null });
  const address = addresses[0];

  const { handleUpdate } = useUpdate('addresses');
  const { handleCreate } = useCreate('addresses');

  const handleSave = useCallback(
    async (event) => {
      event.preventDefault();
      const form = event.target.form;
      const data = new FormData(form);

      const payload = {
        address_1: data.get('street-address'),
        address_2: data.get('address-line-2'),
        city: data.get('city'),
        state: data.get('state'),
        zip: data.get('zip-code'),
        person_id: person.id
      };

      if (!address) {
        await handleCreate(payload);
      } else {
        await handleUpdate(person.id, payload);
      }

      navigate('#birth-info');
    },
    [ address, person ]
  );

  const handleBack = useCallback((event) => {
    event.preventDefault();
    navigate('#user-info');
  }, []);

  console.log(address);

  if (loading) {
    return <div>Loading address...</div>;
  }

  return (
    <ModalFormContainer
      icon="home"
      header="Where do you currently live?"
      step={2}
      steps={4}
    >
      <AddressFormFields address={address} />
      <ErrorMessage message="" />
      <ButtonBar
        handlePrimary={handleSave}
        primaryText="Continue"
        handleSecondary={handleBack}
      />
    </ModalFormContainer>
  );
}

export function AddressFormFields({ address }) {
  // TODO: use address type
  const { address1, address2, city, state, zip } = address ?? ({} as Record<string, string>);

  return (
    <>
      <Input id="street-address" type="text" label="Street Address" defaultValue={address1} />
      <Input id="address-line-2" type="text" label="Address Line 2" defaultValue={address2} />
      <Input id="city" type="text" label="City" defaultValue={city} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Input id="state" type="text" label="State" defaultValue={state} />
        <Input id="zip-code" type="text" label="Zip Code" defaultValue={zip} />
      </div>
    </>
  );
}